export default __webpack_public_path__ + "static/media/register5.885d9629.jpg";